import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';

const createKey = () => ['massActionsRequstPaymentStatus'];

const fetch = () =>
  request.get(
    `/Request/payment_states`,
    null,
    `Произошла ошибка при загрузке доступных статусов оплаты`,
    'Error'
  );

const useFetch = (options) => useQuery(createKey(), () => fetch(), options);

const queryData = { createKey, useFetch };

export default queryData;